import { XingId } from '@xingternal/hub';

type GetProfileUrlWithTrackingArgs = {
  user: XingId;
  trackingParams?: string | string[];
};

export const getProfileUrlWithTracking = ({ user, trackingParams }: GetProfileUrlWithTrackingArgs): string =>
  `/profile/${user?.pageName}?${Array.isArray(trackingParams) ? trackingParams.join('&') : trackingParams}`;
